import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import BackupExportPanel from "../../components/backup/BackupExportPanel";
import { useAuth } from "../../js/hooks/useAuth";

export default function BackupDesk() {
  const { session } = useAuth();
  const [flash, setFlash] = useState("");
  if (!session?.userId) return <Navigate to="/" replace />;

  const variant =
    session.role === "admin"
      ? "admin"
      : session.role === "broker"
        ? "broker"
        : session.role === "agent"
          ? "agent"
          : session.role === "seller"
            ? "seller"
            : "buyer";

  return (
    <AppLayout variant={variant}>
      <div className="account-portal">
        <header className="page-header">
          <div>
            <h1>Backup &amp; export</h1>
            <p className="page-lead">
              Take your checklist and desk data with you. Supported on Windows PC and Apple Mac.
            </p>
            <p className="muted">
              Need a quick rollback instead? <Link to="/restore">Open restore points</Link>
            </p>
          </div>
        </header>
        {flash ? <p className="confirm-banner">{flash}</p> : null}
        <BackupExportPanel session={session} onFlash={setFlash} />
      </div>
    </AppLayout>
  );
}
